const SelectMethodMessages = {
  message1: 'Recolección de Impresión',
  message2: 'Escaneo en clínica',
  message3: 'Subir archivo STL',
  button1: 'Seleccionar'
}

export default SelectMethodMessages
